exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1j9157MGw93nZr8H8-HKqc{position:relative;top:50%;height:0;z-index:100}.k-7GKcbYkr8WGOm7Dr5x2{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;width:100%;height:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);
// Exports
exports.locals = {
	"pageLoading": "_1j9157MGw93nZr8H8-HKqc",
	"mainContent": "k-7GKcbYkr8WGOm7Dr5x2"
};